import { ShiftType } from '@ms/timesheets/dist/models/shift-type';

//List of Shift Types available in edit dropdown
export const WhiteListedShiftTypes = [ShiftType.Regular, ShiftType.OnCall, ShiftType.Charge, ShiftType.Callback];
